import { render, staticRenderFns } from "./commodityLabel.vue?vue&type=template&id=21776174&scoped=true"
import script from "./commodityLabel.vue?vue&type=script&lang=js"
export * from "./commodityLabel.vue?vue&type=script&lang=js"
import style0 from "./commodityLabel.vue?vue&type=style&index=0&id=21776174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21776174",
  null
  
)

export default component.exports